//Basic Font Structure Below:
/*class FontClass{
    size = null
    color = null
    name = null
    url = null
    largest_char = null
    font = null
    ctx = null
    constructor(name,url,size,color,ctx){
        this.name = name
        this.url = url
        this.size = size
        this.color = color
        this.ctx = ctx
    }
    getLargestChar(){}
    measureText(text){}
    autoCurveTest(text,max_width,auto_curve){}
    drawText(text,c_x,c_y){}
    drawTextCurved(text,c_x,c_y,radius,max_arc,letter_spacing = null){}
}*/

window.createOpenTypeFont = function(name,url,size,color,ctx){
    var FontClass = {
        size: null,
        color: null,
        name: null,
        url: null,
        largest_char: null,
        font: null,
        ctx: null,
        construct: function(name,url,size,color,ctx){
            this.name = name
            this.url = url
            this.size = size
            this.color = color
            this.ctx = ctx
            this.checkForFont()
            return this
        },
        checkForFont: function(){
            window.opentype.load(this.url, function(err, font) {
                if(err){
                    console.log('Font Error')
                    console.log(err)
                    console.log(this.url)
                }
                else{
                    this.setFont(font)
                }
            }.bind(this))
        },
        setFont: function(font){
            this.font = font
            this.largest_char = this.getLargestChar()
        },
        getLargestChar: function(){
            var largest = 0
            for(var i = 0;i < 26;i++){
                var measurement = this.font.getAdvanceWidth(String.fromCharCode(97 + i),this.size)
                if(measurement > largest){
                    largest = measurement
                }
                measurement = this.font.getAdvanceWidth(String.fromCharCode(65 + i),this.size)
                if(measurement > largest){
                    largest = measurement
                }
            }
            return largest
        },
        measureText: function(text){
            return this.font.getAdvanceWidth(text,this.size)
        },
        autoCurveTest: function(text,max_width,curved,auto_curve){
            var autocurve = 0
            if(curved == false){
                if(this.measureText(text) > max_width){
                    if(auto_curve == false){
                        while(this.measureText(text) > max_width){
                            text = text.slice(0, -1)
                        }
                    }
                    else{
                        autocurve = 1
                    }
                }
            }
            return [text,autocurve]
        },
        drawText: function(text,c_x,c_y){
            this.ctx.fillStyle = this.color;
            this.ctx.lineWidth = 1.0
            this.ctx.lineJoin = 'round';
            this.font.draw(this.ctx,text,c_x-(this.measureText(text)/2),c_y-(this.size/2))
            return text
        },
        drawTextCurved: function(text,c_x,c_y,radius,max_arc,letter_spacing = null){
            if(letter_spacing == null){
                letter_spacing = this.largest_char
            }
            this.ctx.fillStyle = this.color;
            this.ctx.lineWidth = 1.0
            this.ctx.lineJoin = 'round';
        
            var font_angle = (Math.asin(((letter_spacing+4.0)/2)/radius)*180/Math.PI)
        
            var arc = font_angle*text.length
            if(arc > max_arc){
                while(arc > max_arc){
                    text = text.slice(0, -1)
                    arc = font_angle*text.length
                }
            }
            var origin = -(parseFloat(arc) / 2.0)
        
            this.ctx.translate(c_x, c_y);
        
            for (var n = 0; n < text.length; n++) {
                this.ctx.save();
                
                var rotation = origin+(font_angle*n)+(font_angle*0.5)
                this.ctx.rotate(rotation * Math.PI / 180);
                this.ctx.translate(0, -radius);
        
                var char = text[n];
                this.font.draw(this.ctx,char,0,0)
        
                this.ctx.restore();
            }
        
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            return text
        }
    }
    return FontClass.construct(name,url,size,color,ctx)
}

window.createTTFFont = function(name,url,size,color,ctx){
    var FontClass = {
        size: null,
        color: null,
        name: null,
        url: null,
        largest_char: null,
        font: null,
        ctx: null,
        construct: function(name,url,size,color,ctx){
            this.name = name
            this.url = url
            this.size = size
            this.color = color
            this.ctx = ctx
            this.checkForFont()
            return this
        },
        checkForFont: function(){
            fetch(this.url)
            .then(function(response){
                return response.blob()
            }.bind(this))
            .then(function (blob) {
                var reader = new FileReader();
                reader.readAsDataURL(blob); 
                reader.onloadend = function() {
                    if($('style[data-customiser-font="'+this.name+'"]').length == 0){
                        var dataUrl = 'url('+reader.result+')'
                        var format = blob.type.split('/')[1]
                        if(format == 'otf'){
                        format = 'opentype'
                        }
                        if(format == 'ttf'){
                        format = 'truetype'
                        }
                        if(format == 'eot'){
                        format = 'embedded-opentype'
                        }
                        var datatag = '<style data-customiser-font="'+this.name+'">@font-face {font-family: "'+this.name+'";src: '+dataUrl+' format("'+format+'");font-weight: 400;}</style>'
                        $('head').append(datatag)
                    }
                    this.setFont()
                }.bind(this)
            }.bind(this))
        },
        setFont: function(){
            this.font = this.size+'px "'+this.name+'"'
            this.largest_char = this.getLargestChar()
        },
        getLargestChar: function(){
            this.ctx.font = this.font
            this.ctx.lineWidth = 1.0
            var largest = 0
            for(var i = 0;i < 26;i++){
                var measurement = this.ctx.measureText(String.fromCharCode(97 + i))
                var width = Math.abs(measurement.actualBoundingBoxLeft) + Math.abs(measurement.actualBoundingBoxRight)
                if(width > largest){
                    largest = width
                }
                measurement = this.ctx.measureText(String.fromCharCode(65 + i))
                width = Math.abs(measurement.actualBoundingBoxLeft) + Math.abs(measurement.actualBoundingBoxRight)
                if(width > largest){
                    largest = width
                }
            }
            return largest
        },
        measureText: function(text){
            this.ctx.font = this.font
            this.ctx.lineWidth = 1.0
            return this.ctx.measureText(text)
        },
        autoCurveTest: function(text,max_width,curved,auto_curve){
            var autocurve = 0
        
            this.ctx.font = this.font
            this.ctx.lineWidth = 1.0
            
            if(curved == false){
                if(this.measureText(text).width > max_width){
                    if(auto_curve == false){
                        while(this.measureText(text).width > max_width){
                            text = text.slice(0, -1)
                        }
                    }
                    else{
                        autocurve = 1
                    }
                }
            }
            return [text,autocurve]
        },
        drawText: function(text,c_x,c_y){
            this.ctx.font = this.font
            this.ctx.fillStyle = this.color;
            this.ctx.textAlign = "center";
            this.ctx.lineWidth = 1.0
            this.ctx.lineJoin = 'round';
            this.ctx.fillText(text, c_x, c_y);
            return text
        },
        drawTextCurved: function(text,c_x,c_y,radius,max_arc,letter_spacing = null){
            if(letter_spacing == null){
                letter_spacing = this.largest_char
            }
            this.ctx.font = this.font
            this.ctx.fillStyle = this.color;
            this.ctx.textAlign = "center";
            this.ctx.lineWidth = 1.0
            this.ctx.lineJoin = 'round';
        
            var font_angle = (Math.asin(((letter_spacing+4.0)/2)/radius)*180/Math.PI)
        
            var arc = font_angle*text.length
            if(arc > max_arc){
                while(arc > max_arc){
                    text = text.slice(0, -1)
                    arc = font_angle*text.length
                }
            }
            var origin = -(parseFloat(arc) / 2.0)
        
            this.ctx.translate(c_x, c_y);
        
            for (var n = 0; n < text.length; n++) {
                this.ctx.save();
                
                var rotation = origin+(font_angle*n)+(font_angle*0.5)
                this.ctx.rotate(rotation * Math.PI / 180);
                this.ctx.translate(0, -radius);
        
                var char = text[n];
                this.ctx.fillText(char, 0, 0);
        
                this.ctx.restore();
            }
        
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            return text
        }
    }
    return FontClass.construct(name,url,size,color,ctx)
}